module.exports = __webpack_public_path__ + "img/salario.6c52d6a2.jpg";